<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算对象</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.full_name_rid">
                <el-select filterable v-model="full_name_rid" placeholder="请选择全名称" :clearable="true">
                    <el-option v-for="item in parentOptions" :key="item.rid" :label="item.full_name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.full_label_rid">
                <el-select filterable v-model="full_label_rid" placeholder="请选择全标签" :clearable="true">
                    <el-option v-for="item in parentOptions" :key="item.rid" :label="item.full_label" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.parent_rid">
                <el-select filterable v-model="parent_rid" placeholder="请选择对象上级" :clearable="true">
                    <el-option v-for="item in parentOptions" :key="item.rid" :label="item.full_name" :value="item.rid"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增预算对象</el-button>
                <el-button size="small" plain @click="updateData" :loading="updateLoading" v-if="postList.updateBtn"
                    >同步到预算科目</el-button
                >
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="budget_object"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_object"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <!-- 上级标签处理 -->
                            <div v-if="item.prop == 'code' || item.prop == 'name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'parent'">
                                <el-link
                                    v-if="scope.row.parent"
                                    type="primary"
                                    @click="handleClick(scope.row, item.prop)"
                                    style="font-size: 11px"
                                    >{{ scope.row.parent.name }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import bus from '../../../../common/bus';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'budgetObjectListComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_object'
            },
            parentOptions: [],
            down_loading: false,
            updateLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            code: '', //code
            name: '', // 名称
            label: '', //标签
            full_name_rid: '', //全名称
            full_label_rid: '', //全标签
            parent_rid: '', //对象上级
            postList1: {}
        };
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.parent_rid) {
                        this.parent_rid = newValue.params.parent_rid;
                        this.getList(0); //获取列表
                    }
                }
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['budgetObject_params']) {
                this.page = paramsList['budgetObject_params'].page;
                this.row = paramsList['budgetObject_params'].row;
                this.name = paramsList['budgetObject_params'].name;
                // this.data_name = paramsList['budgetObject_params'].data_name;
                // this.sort = paramsList['budgetObject_params'].sort;
                this.code = paramsList['budgetObject_params'].code;
                this.label = paramsList['budgetObject_params'].label;
                this.parent_rid = paramsList['budgetObject_params'].parent_rid;
                this.full_label_rid = paramsList['budgetObject_params'].full_label_rid;
                this.full_name_rid = paramsList['budgetObject_params'].full_name_rid;
            }
        }
    },
    props: {
        postList: {
            type: Object
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getParent(); //科目上级下拉
                this.getList(0); //获取列表
            }
        });
    },

    methods: {
        //同步到预算项目
        updateData() {
            let messages = '您确定要同步到预算科目吗?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.updateLoading = true;
                    let params = {};
                    this.$api
                        .budgetObjectSyncToSubject(params)
                        .then((res) => {
                            this.updateLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '同步成功',
                                    type: 'success'
                                });
                            }
                        })
                        .catch((error) => {
                            this.updateLoading = false;
                        });
                })
                .catch(() => {
                    this.updateLoading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消同步'
                    });
                });
        },
        //获取科目上级下拉
        getParent() {
            let params = {};
            this.$api
                .dropdownBudgetObject(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.parentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_object', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_object;
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'budgetObjectEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'budgetObjectEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(row) {
            var params = {
                id: row
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .budgetObjectDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetObject_params']) {
                    newParamsList['budgetObject_params'].data_name = val.prop;
                    newParamsList['budgetObject_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'budgetObjectEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                this.$router.push({
                    path: '/budgetObjectDetails',
                    query: {
                        id: row.rid
                    }
                });
                bus.$emit('update', row.rid);
                if (this.postList.params) {
                    this.postList1.params.parent_rid = row.rid;
                }
            } else if (prop == 'parent') {
                this.$router.push({
                    path: '/budgetObjectDetails',
                    query: {
                        id: row.parent_rid
                    }
                });
                bus.$emit('update', row.parent_rid);
                if (this.postList.params) {
                    this.postList1.params.parent_rid = row.parent_rid;
                }
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                name: this.name,
                label: this.label,
                full_name_rid: this.full_name_rid,
                full_label_rid: this.full_label_rid,
                parent_rid: this.parent_rid,
                sort: [this.data_name, this.sort],
                code: this.code,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['budgetObject_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.$api
                    .budgetObjectLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['budgetObject_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetObjectListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetObject_params']) {
                    newParamsList['budgetObject_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        label: this.label,
                        full_name_rid: this.full_name_rid,
                        full_label_rid: this.full_label_rid,
                        parent_rid: this.parent_rid,
                        sort: [this.data_name, this.sort],
                        code: this.code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetObject_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetObject_params']) {
                    newParamsList['budgetObject_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        label: this.label,
                        full_name_rid: this.full_name_rid,
                        full_label_rid: this.full_label_rid,
                        parent_rid: this.parent_rid,
                        sort: [this.data_name, this.sort],
                        code: this.code
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetObject_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.name = '';
            this.label = '';
            this.full_name_rid = '';
            this.full_label_rid = '';
            this.sort = '';
            this.data_name = '';
            this.parent_rid = '';
            this.page = 1;
            this.row = 25;
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                code: '',
                name: '',
                label: '',
                full_name_rid: '',
                full_label_rid: '',
                parent_rid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['budgetObject_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.status_1 {
    color: green;
}
.status_2 {
    color: red;
}
</style>